export const GLOBAL_VARIABLES_CACHE_KEY = 'APP_GLOBAL_VARIABLES_CACHE'

export const GLOBAL_VARIABLES_EVENT = 'GLOBAL_VARIABLES_EVENT'

/**
 * 根据传入的 region 返回对应的 biot-apps API 域名
 * @param region 区域标识，默认为 'cn1'
 * @returns 形如 https://api-${region}.biot-apps.com 的域名
 */
export function getBiotAppsApiDomain(region?: string): string {
  const _region = region && region.trim() ? region.trim() : 'cn1'
  return `https://api-${_region}.biot-apps.com`
}

/**
 * 替换 biot-apps.com 域名中的 region 部分为传入的 region
 * 支持格式: https://api-{region}.biot-apps.com 和 https://api-{region}.{env}.biot-apps.com
 * 其中 {env} 可以是 pre、dev、uat 等任意环境标识符
 * @param url 需要替换的 url
 * @param region 新的 region
 * @returns 替换后的 url，如果未匹配到则返回原 url
 */
export function replaceBiotAppsRegion(url: string, region: string): string {
  if (!region || !region.trim()) return url
  const reg = /(https:\/\/api-)([^.]+)((?:\.[^.]+)?\.biot-apps\.com)/
  if (reg.test(url)) {
    return url.replace(reg, `$1${region.trim()}$3`)
  }
  return url
}


export async function getNetStatus(): Promise<TNetStatus> {
  // const connection = navigator.connection
  const isConnect = navigator?.onLine || 'unkown'
  // const { effectiveType = 'unkown' } = connection || {}
  return { isConnect, networkType: 'unkown', isWifi: true }
}
